import { Commit } from 'vuex';
import { SuiviFacturesEnRetardState } from './state';

export enum SuiviFacturesEnRetard {
    GET_SUIVI_FACTURES_EN_RETARD = 'GET_SUIVI_FACTURES_EN_RETARD',
    GET_FACTURES_EN_RETARD_PDF = 'GET_FACTURES_EN_RETARD_PDF'
}

export interface SuiviFacturesEnRetardActionTypes {
    commit: Commit,
    state: SuiviFacturesEnRetardState,
    getters: any
}
